// extracted by mini-css-extract-plugin
export default {"fieldheader":"b0ef145a22142d268210","icon":"ac89b89af9f3bd587567","name":"b4e5f05b54e89ecd52c9","requiredbadge":"bffe2e99ac95a39d7345","defaultvaluebadge":"ae1d7a49a7bd1861f416"};